const authenticationRoutes = {
    LOGIN: '/authentication-token',
    RESET_PASSWORD_REQUEST: '/reset-password-requests',
    RESET_PASSWORD: '/reset-password-requests/{token}',
    TOKEN_REFRESH: '/token/refresh',
};
export { authenticationRoutes };
//# sourceMappingURL=endpoints.js.map